<template>
    <div class="form-item">
        <label class="label-caption">Opção Menu</label>
        <select :value="idSelecionado" :disabled="props.disabled" @change="atualizarSelecao" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.titulo }}</option>
        </select>
    </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import { Api } from "@/funcoes/apiExport";
import { globalStore } from "@/globals";

const emit = defineEmits(['update:idSelecionado', 'update:objSelecionado'])
const props = defineProps({
    ckAddTodos: {type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    idSelecionado: {type: Number, default: null,},
})
const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await Api.genericPost('/listas/epmenuproc', {
            idep: globalStore.idep,
            ativo: "S"});
        lsDados.value = response;
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, titulo: 'TODOS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;}
}

const atualizarSelecao = (event) => {
    const selectedId = Number(event.target.value);
    emit("update:idSelecionado", selectedId);

    const selectedObj = lsDados.value.find((obj) => obj.id === selectedId);
    if (selectedObj) {emit("update:objSelecionado", selectedObj);}
}

onMounted(() => {
    if (props.ckPesquisar){
        fetchData();
    }
})

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
)
</script>
  